module.exports = __webpack_public_path__ + "static/client1-346d3541a42cf20c1c3db67a2df686e0.jpeg";